import React from "react";
var __jsx = React.createElement;
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import AwesomeIcon from "../AwesomeIcon";
import { faBars, faXmark } from "@fortawesome/pro-regular-svg-icons";
import Button from "../common/Button";
import StepNavigation from "./StepNavigation";
var ScanFlowLayout = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    progress = _ref.progress,
    steps = _ref.steps,
    currentStepIndex = _ref.currentStepIndex,
    _ref$maxVisible = _ref.maxVisible,
    maxVisible = _ref$maxVisible === void 0 ? 7 : _ref$maxVisible,
    onStepClick = _ref.onStepClick,
    isStepDisabled = _ref.isStepDisabled,
    isStepComplete = _ref.isStepComplete,
    children = _ref.children,
    buttonLabel = _ref.buttonLabel,
    onButtonClick = _ref.onButtonClick,
    _ref$showSkip = _ref.showSkip,
    showSkip = _ref$showSkip === void 0 ? true : _ref$showSkip,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onSkip = _ref.onSkip,
    onClose = _ref.onClose,
    menuItems = _ref.menuItems,
    activeMenuItemId = _ref.activeMenuItemId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    menuOpen = _useState[0],
    setMenuOpen = _useState[1];
  var handleMenuSelect = function handleMenuSelect(item) {
    if (item.disabled) return;
    item.onSelect();
    setMenuOpen(false);
  };
  var hasMenu = menuItems && menuItems.length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col flex-1 min-h-0 relative overflow-hidden"
  }, hasMenu && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: -1,
    onClick: function onClick() {
      return setMenuOpen(false);
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === "Escape" && setMenuOpen(false);
    },
    className: "absolute inset-0 z-20 transition-opacity duration-200 ".concat(menuOpen ? "bg-black/50" : "pointer-events-none bg-transparent opacity-0"),
    "aria-hidden": !menuOpen
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute left-0 right-0 top-0 z-30 flex flex-col bg-gray-800 rounded-b-[20px] shadow-xl transition-transform duration-200 ease-out ".concat(menuOpen ? "translate-y-0" : "-translate-y-full")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-5 px-5 py-4 border border-gray-700 rounded-t-2xl"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setMenuOpen(false);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faBars,
    size: "lg",
    className: "text-teal-300 shrink-0"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-white font-medium text-base"
  }, t("menu", "Menu"))), /*#__PURE__*/React.createElement("nav", {
    className: "py-1 overflow-hidden"
  }, menuItems.map(function (item) {
    var isActive = activeMenuItemId === item.id;
    return /*#__PURE__*/React.createElement("button", {
      key: item.id,
      type: "button",
      onClick: function onClick() {
        return handleMenuSelect(item);
      },
      disabled: item.disabled,
      className: "w-full text-left px-5 py-3.5 text-base transition-colors border-b border-gray-700/60 last:border-b-0 flex items-center ".concat(item.disabled ? "text-gray-500 cursor-not-allowed hidden" : isActive ? "text-teal-300 bg-gray-700/50" : "text-gray-300 hover:bg-gray-700/40")
    }, item.label);
  })))), /*#__PURE__*/React.createElement("div", {
    className: "drag-handle cursor-grab active:cursor-grabbing rounded-t-2xl bg-gray-800 flex items-center justify-between px-6 py-4 relative border border-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-5"
  }, hasMenu ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setMenuOpen(function (prev) {
        return !prev;
      });
    },
    className: "p-1 rounded hover:bg-gray-700/50 transition-colors",
    "aria-label": t("menu", "Menu"),
    "aria-expanded": menuOpen
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faBars,
    size: "lg",
    className: "text-teal-300"
  })) : /*#__PURE__*/React.createElement("span", {
    className: "p-1",
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faBars,
    size: "lg",
    className: "text-teal-300"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "text-white text-base font-medium"
  }, title)), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "text-gray-400 hover:text-gray-200 transition-colors p-1",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "h-[4px] w-full bg-gray-700"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full bg-[#008280] shadow-[0_0_4px_0_rgba(0,208,205,0.5)] transition-all duration-500",
    style: {
      width: "".concat(progress, "%")
    }
  })), /*#__PURE__*/React.createElement(StepNavigation, {
    steps: steps,
    currentIndex: currentStepIndex,
    maxVisible: maxVisible,
    onStepClick: onStepClick,
    isStepDisabled: isStepDisabled,
    isStepComplete: isStepComplete
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-h-0 flex flex-col items-center justify-center px-6 pb-7 overflow-y-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full rounded-2xl flex flex-col flex-1 min-h-0 items-center justify-between"
  }, children, /*#__PURE__*/React.createElement("div", {
    className: "space-y-3 w-full pt-7"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onButtonClick,
    isPrimary: true,
    className: "w-full ".concat(isDisabled ? "opacity-50 cursor-not-allowed" : ""),
    disabled: isDisabled
  }, buttonLabel), showSkip && onSkip && /*#__PURE__*/React.createElement("button", {
    onClick: isDisabled ? undefined : onSkip,
    disabled: isDisabled,
    className: "w-full py-3 text-base font-medium transition-colors ".concat(isDisabled ? "text-gray-600 cursor-not-allowed" : "text-gray-400 hover:text-gray-300")
  }, t("skip", "Skip"))))));
});
ScanFlowLayout.displayName = "ScanFlowLayout";
export default ScanFlowLayout;